import {
  EDisplayName,
  EFieldsName,
  IDataPreference
} from "@/features/financas/views/Indicadores/@types/type";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { IFluxoDeCaixaStrategy } from "../../Preferencias/strategy/preferenciasInterfaces";
import Preferencia from "../../Preferencias/strategy/Preferencia";

export default class FluxoDeCaixaStrategy implements IFluxoDeCaixaStrategy {
  createCompanies(companies: string[]): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.contas,
      fieldData: companies.join(","),
      displayName: EDisplayName.fluxoCaixaPainel,
      id: EWidgets.FluxoCaixaPainel
    });

    return preferencia.createPreferencesData();
  }

  createPlanoOrcamentario(
    planos: string[]
  ): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.fluxoPlanosOrcamentarios,
      fieldData: planos.join(","),
      displayName: EDisplayName.fluxoCaixaPainel,
      id: EWidgets.FluxoCaixaPainel
    });

    return preferencia.createPreferencesData();
  }

  createStatus(fieldValue: number): IDataPreference {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.fluxoStatus,
      fieldData: fieldValue,
      displayName: EDisplayName.fluxoCaixaPainel,
      id: EWidgets.FluxoCaixaPainel
    });

    return preferencia.createPreferencesData();
  }

  createCheckbox(fieldName: string, fieldValue: boolean): IDataPreference {
    const preferencia = new Preferencia({
      fieldName: fieldName,
      fieldData: fieldValue,
      displayName: EDisplayName.fluxoCaixaPainel,
      id: EWidgets.FluxoCaixaPainel
    });

    return preferencia.createPreferencesData();
  }
}
